/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';

type Props = {
  className?: string,
  direction?: 'down' | 'up',
};

const defaultProps = {
  className: undefined,
  direction: undefined,
};

const DownArrow = glamorous.span(({ theme }) => ({
  color: theme.color.danger,
}), 'ion-arrow-down-b');

const UpArrow = glamorous.span(({ theme }) => ({
  color: theme.color.success,
}), 'ion-arrow-up-b');

function Trend({ className, direction }: Props) {
  switch (direction) {
    case 'down':
      return <DownArrow className={className} />;
    case 'up':
      return <UpArrow className={className} />;
    default:
  }

  return null;
}

Trend.defaultProps = defaultProps;

export default Trend;
